// extracted by mini-css-extract-plugin
export default {"modalContainer":"modal_modalContainer__9Wni6","modalHead":"modal_modalHead__Rm3a6","title":"modal_title__IcF-K","close":"modal_close__KgWfb","footer":"modal_footer__jiSW2"};